/** Playing the moves you missed by itself, when you open a game with new moves; it ends in the live game. */
export const CATCH_UP = 'catch-up';
/** Stepping through the game's moves by hand (the Replay button). */
export const REPLAY = 'replay';

/** How long each move shows while catching up, and how long the last one stays before the live game. */
export const CATCH_UP_STEP_MS = 1300;
export const CATCH_UP_END_MS = 1500;
